import React, { FC } from 'react';

import { Grid } from '@mui/material';

import { SelectComponentControl } from 'components/_basic/SelectComponent/SelectComponentControl';

import { IBaseSelectorProps } from './types';

export const BaseSelector: FC<IBaseSelectorProps> = ({
  name,
  disabled,
  options,
  defaultValue,
  label,
  containerProps = {},
}) => {
  return (
    <Grid container gap="8px" {...containerProps}>
      <span>{label}</span>
      <SelectComponentControl
        sx={{  maxWidth: '120px' }}
        id={name}
        name={name}
        disabled={disabled}
        options={options}
        defaultValue={defaultValue}
        onClick={(e) => e.preventDefault()}
      />
    </Grid>
  );
};
